import {
  INVOICE_UPLOAD_ACCEPTED_TYPES,
  INVOICE_UPLOAD_MAX_FILE_SIZE,
  SETTING_ENABLED,
} from '../constants/constants';

// For customers the JJ Price Compare AI link is behind the `priceCompare` Strapi
// setting, but staff always see it — they need it to run comparisons for any
// account regardless of how the flag is currently set. Used by both the burger
// menu and the top bar dropdown, so it lives here rather than in either.
export const showPriceCompareLink = (settings, isStaffAccount) =>
  !!isStaffAccount || !!(settings && settings.priceCompare === SETTING_ENABLED);

// Invoice dates arrive in mixed formats: ISO (e.g. "2026-05-16") for most, but
// some suppliers' invoices come through as DD/MM/YY or DD/MM/YYYY (e.g.
// "30/10/25"), which `new Date()` cannot parse and renders as "Invalid Date".
const parseInvoiceDate = dateStr => {
  if (dateStr instanceof Date) {
    return isNaN(dateStr.getTime()) ? null : dateStr;
  }
  if (typeof dateStr !== 'string') {
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  }
  const trimmed = dateStr.trim();
  const dmy = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (dmy) {
    const day = parseInt(dmy[1], 10);
    const month = parseInt(dmy[2], 10);
    let year = parseInt(dmy[3], 10);
    if (year < 100) year += 2000;
    const d = new Date(year, month - 1, day);
    // Reject impossible dates (e.g. 13/13/25) that the Date constructor would
    // otherwise silently roll over into the following month/year.
    if (
      d.getFullYear() !== year ||
      d.getMonth() !== month - 1 ||
      d.getDate() !== day
    ) {
      return null;
    }
    return d;
  }
  const d = new Date(trimmed);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = dateStr => {
  if (!dateStr) return '-';
  const d = parseInvoiceDate(dateStr);
  if (!d) return '-';
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const formatCurrency = val => {
  if (val == null) return '-';
  return `\u00a3${val.toFixed(2)}`;
};

export const formatFileSize = bytes => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const validateFile = file => {
  if (!INVOICE_UPLOAD_ACCEPTED_TYPES.includes(file.type)) {
    return `${file.name}: unsupported format. Use PDF, JPEG, PNG, or WebP.`;
  }
  if (file.size > INVOICE_UPLOAD_MAX_FILE_SIZE) {
    return `${file.name}: file too large (${formatFileSize(
      file.size
    )}). Maximum is 20 MB.`;
  }
  return null;
};
